import { Powered } from 'component/Powered/Powered'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'

export const Footer = observer(() => {
  return <Space tall center>
    <Powered />
  </Space>
})
